/*
 * Scheda prodotto Genovese.
 * - Cambio variante: Trade ricarica la sezione e pubblica `variantChange`; qui si
 *   aggiornano i nostri elementi con data-gm-aggiorna (codice, rate, consegna, prezzo
 *   della barra) copiandoli dall'HTML nuovo, e le righe Codice/EAN della scheda Dettagli.
 * - Schede «Caratteristiche / Dettagli» (tab con frecce, Home, Fine) e «Continua a leggere».
 * - Galleria su mobile: pallini sotto la foto.
 * - Barra d'acquisto fissa su mobile, quando il pulsante principale è già passato.
 */

/* ── Cambio variante ─────────────────────────────────────────────── */
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && !window.gmProdottoIscritto) {
  window.gmProdottoIscritto = true;

  subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { sectionId, html, variant } }) => {
    const info = document.querySelector(`product-info[data-section="${sectionId}"]`);
    if (info) {
      info.querySelectorAll('[data-gm-aggiorna][id]').forEach((elemento) => {
        const nuovo = html.getElementById(elemento.id);
        if (!nuovo) return;
        if (elemento.dataset.gmAggiorna === 'contenuto') elemento.innerHTML = nuovo.innerHTML;
        elemento.hidden = nuovo.hidden;
      });
    }

    if (!variant) return;
    document.querySelectorAll('[data-gm-variante]').forEach((riga) => {
      const valore = variant[riga.dataset.gmVariante] || '';
      const cella = riga.querySelector('[data-gm-valore]');
      if (cella) cella.textContent = valore;
      riga.hidden = valore === '';
    });

    // Potenza e moduli (custom.* di variante): valori preparati da gm-dettagli.
    const mappa = document.querySelector('[data-gm-dettagli-varianti]');
    if (!mappa) return;
    const campi = JSON.parse(mappa.textContent)[variant.id] || {};
    document.querySelectorAll('[data-gm-campo-variante]').forEach((riga) => {
      const valore = (campi[riga.dataset.gmCampoVariante] || '').trim();
      riga.querySelector('[data-gm-valore]').textContent = valore;
      riga.hidden = valore === '';
    });
  });
}

/* ── Schede ──────────────────────────────────────────────────────── */
if (!customElements.get('gm-schede')) {
  customElements.define(
    'gm-schede',
    class GmSchede extends HTMLElement {
      connectedCallback() {
        this.tab = Array.from(this.querySelectorAll('[role="tab"]'));
        this.tab.forEach((tab) => {
          tab.addEventListener('click', () => this.attiva(tab));
          tab.addEventListener('keydown', (evento) => this.tastiera(evento, tab));
        });
        this.querySelectorAll('[data-gm-leggi]').forEach((blocco) => this.leggiTutto(blocco));
      }

      attiva(scelta, focus = false) {
        this.tab.forEach((tab) => {
          const attiva = tab === scelta;
          tab.setAttribute('aria-selected', String(attiva));
          tab.tabIndex = attiva ? 0 : -1;
          const pannello = document.getElementById(tab.getAttribute('aria-controls'));
          if (pannello) pannello.hidden = !attiva;
        });
        if (focus) scelta.focus();
        // Il pannello appena mostrato può avere un testo lungo da accorciare.
        document
          .getElementById(scelta.getAttribute('aria-controls'))
          ?.querySelectorAll('[data-gm-leggi]')
          .forEach((blocco) => this.leggiTutto(blocco));
      }

      tastiera(evento, tab) {
        const i = this.tab.indexOf(tab);
        const vai = {
          ArrowRight: (i + 1) % this.tab.length,
          ArrowLeft: (i - 1 + this.tab.length) % this.tab.length,
          Home: 0,
          End: this.tab.length - 1,
        }[evento.key];
        if (vai === undefined) return;
        evento.preventDefault();
        this.attiva(this.tab[vai], true);
      }

      leggiTutto(blocco) {
        const testo = blocco.querySelector('.gm-leggi__testo');
        const pulsante = blocco.querySelector('.gm-leggi__pulsante');
        if (!testo || !pulsante || blocco.dataset.pronto) return;
        if (!testo.offsetParent) return; // pannello nascosto: si misura quando si apre
        blocco.dataset.pronto = 'true';
        if (testo.scrollHeight <= testo.clientHeight + 24) {
          blocco.classList.add('gm-leggi--corto');
          return;
        }
        pulsante.hidden = false;
        pulsante.addEventListener('click', () => {
          const aperto = blocco.classList.toggle('gm-leggi--aperto');
          pulsante.setAttribute('aria-expanded', String(aperto));
          pulsante.textContent = aperto ? pulsante.dataset.testoAperto : pulsante.dataset.testoChiuso;
          if (!aperto) blocco.closest('.gm-schede')?.scrollIntoView({ block: 'start' });
        });
      }
    }
  );
}

/* ── Galleria su mobile: pallini ─────────────────────────────────── */
function gmPallini(galleria) {
  const pista = galleria.querySelector('.product__media-list');
  if (!pista || galleria.querySelector('.gm-pallini')) return;
  const foto = Array.from(pista.children).filter((li) => li.matches('.product__media-item'));
  if (foto.length < 2) return;

  const pallini = document.createElement('div');
  pallini.className = 'gm-pallini';
  pallini.setAttribute('aria-hidden', 'true');
  foto.forEach(() => pallini.appendChild(document.createElement('span')));
  pista.closest('slider-component')?.after(pallini);

  const segna = () => {
    const visibili = foto.filter((li) => li.clientWidth > 0);
    if (!visibili.length) return;
    const passo = visibili[0].clientWidth || 1;
    const indice = Math.min(visibili.length - 1, Math.round(pista.scrollLeft / passo));
    Array.from(pallini.children).forEach((p, i) => p.toggleAttribute('data-attivo', i === indice));
  };
  pista.addEventListener('scroll', segna, { passive: true });
  segna();
}

/* ── Barra d'acquisto fissa (mobile) ─────────────────────────────── */
function gmBarra(info) {
  const barra = info.querySelector('[data-gm-barra]');
  const principale = info.querySelector('.product-form__submit');
  if (!barra || !principale || barra.dataset.pronta) return;
  barra.dataset.pronta = 'true';

  const pulsante = barra.querySelector('[data-gm-barra-pulsante]');
  const copia = () => {
    pulsante.disabled = principale.disabled;
    const etichetta = principale.querySelector('span')?.textContent.trim();
    if (etichetta) pulsante.textContent = etichetta;
  };
  copia();
  new MutationObserver(copia).observe(principale, { attributes: true, childList: true, subtree: true });
  pulsante.addEventListener('click', () => {
    principale.click();
  });

  // Posizione letta a ogni scroll (una volta per frame): un IntersectionObserver non
  // scatta se uno scorrimento veloce salta il pulsante tra due frame.
  const mobile = window.matchMedia('(max-width: 749px)');
  let inAttesa = false;
  const aggiorna = () => {
    inAttesa = false;
    const mostra = mobile.matches && principale.getBoundingClientRect().bottom < 0;
    if (barra.hidden === !mostra) return;
    barra.hidden = !mostra;
    document.body.classList.toggle('gm-barra-attiva', mostra);
  };
  window.addEventListener(
    'scroll',
    () => {
      if (inAttesa) return;
      inAttesa = true;
      requestAnimationFrame(aggiorna);
    },
    { passive: true }
  );
  mobile.addEventListener('change', aggiorna);
  aggiorna();
}

function gmAvvia() {
  document.querySelectorAll('product-info').forEach((info) => {
    info.querySelectorAll('media-gallery').forEach(gmPallini);
    gmBarra(info);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', gmAvvia);
} else {
  gmAvvia();
}
